import { jsx as _jsx } from "react/jsx-runtime";
export const PrevArrowIcon = ({ disabled })=>/*#__PURE__*/ _jsx("svg", {
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.346487 6.42259L6.06241 0.818848C6.19461 0.689135 6.37109 0.617676 6.55926 0.617676C6.74744 0.617676 6.92391 0.689135 7.05612 0.818848L7.47705 1.23143C7.75096 1.50027 7.75096 1.93722 7.47705 2.20565L2.67726 6.91134L7.48238 11.6222C7.61458 11.752 7.68758 11.9249 7.68758 12.1093C7.68758 12.2938 7.61458 12.4668 7.48238 12.5966L7.06144 13.0091C6.92914 13.1388 6.75276 13.2102 6.56459 13.2102C6.37641 13.2102 6.19993 13.1388 6.06773 13.0091L0.346487 7.40019C0.213972 7.27007 0.141187 7.09633 0.141603 6.91165C0.141187 6.72624 0.213972 6.55261 0.346487 6.42259Z",
            fill: disabled ? "#C5C7D0" : "#6161FF"
        })
    });
